// SidebarContext.js
import { createContext, useEffect, useState } from "react";

export const SidebarContext = createContext();

export const SidebarProvider = ({ children }) => {
    const [showLargeScreenSidebar, setShowLargeScreenSidebar] = useState(true);
    const [showHighYieldSidebar, setShowHighYieldSidebar] = useState(false);
    const [showExtendedTextbookSidebar, setShowExtendedTextbookSidebar] = useState(false);
    const [showUserProfileSidebar, setShowUserProfileSidebar] = useState(false);
    const [showSmallScreenSidebar, setShowSmallScreenSidebar] = useState(false);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    const toggleSidebar = () => {
        setShowLargeScreenSidebar(!showLargeScreenSidebar);
    };

    const toggleHighYieldSidebar = () => {
        setShowHighYieldSidebar(!showHighYieldSidebar);
    };

    const toggleExtendedTextbookSidebar = () => {
        setShowExtendedTextbookSidebar(!showExtendedTextbookSidebar);
    };

    const toggleShowUserProfileSidebar = () => {
        setShowUserProfileSidebar(!showUserProfileSidebar);
    };

    const toggleSmallScreenSidebar = () => {
        setShowSmallScreenSidebar(!showSmallScreenSidebar);
    };

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
            if (windowWidth > 600) {
                setShowSmallScreenSidebar(false); // Ensure small screen sidebar is closed on larger screens
            }
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [windowWidth]);

    useEffect(() => {
        if (windowWidth <= 600) {
            setShowLargeScreenSidebar(false); // Initially hide the main sidebar on small screens
        } else {
            setShowLargeScreenSidebar(true); // Initially show the main sidebar on larger screens
            setShowSmallScreenSidebar(false); // Ensure small screen sidebar is closed on larger screens
        }
    }, [windowWidth]);

    return (
        <SidebarContext.Provider value={{
            toggleSidebar,
            showLargeScreenSidebar,
            setShowLargeScreenSidebar,
            toggleHighYieldSidebar,
            showHighYieldSidebar,
            toggleExtendedTextbookSidebar,
            showExtendedTextbookSidebar,
            toggleShowUserProfileSidebar,
            showUserProfileSidebar,
            showSmallScreenSidebar,
            toggleSmallScreenSidebar
        }}>
            {children}
        </SidebarContext.Provider>
    )
}